<template id="event-success">

    <div class="panel m-b-15 rounded-lg" id="event-success-panel">

        <div class="panel-body" id="event-success-booking" v-if="info && membershipPlan">

            <div class="row">
                <div class="col-xs-12 text-center m-t-40 m-b-30">
                    <i class="zmdi zmdi-check-circle booking-success-icon"></i>
                    <h3 class="m-b-30" v-if="payment">{{ trans('apps.memberships.purchase_success', { name: membershipPlan.name }) }}</h3>
                    <h4 class="m-b-30" v-if="payment && payment.amount > 0">{{ trans('apps.memberships.purchase_success_description') }}</h4>
                </div>
            </div>

        </div>
    </div>

</template>

<script type="text/javascript">
export default {
    data () {
        return {
            membershipPlan: null,
            signup: null,
            info: null,
            can_use_analytics: false,
            payment: null,
            logged_in_client: false
        }
    },

    mounted() {

        this.$event_bus.$on('LoadMembershipData', ({ can_use_analytics, logged_in_client }) => {
            this.can_use_analytics = can_use_analytics;
            this.logged_in_client = logged_in_client;
        });

        this.$event_bus.$on('infoMembershipAdded', (data) => {
            this.membershipPlan = data.membership_plan;
            this.purchase = data.purchase;
            this.signup = data.signup;
            this.info = data.data;
            this.payment = data.payment;

            if (this.can_use_analytics && typeof gtag === 'function') {

                gtag('event', 'Purchase', {
                    'event_category': system_name,
                    'event_action': 'subscription-package-purchase',
                    'event_label': this.membershipPlan.name,
                    'event_value': parseInt(data.payment.amount) / 100,
                });
            }
        });
    }
};
</script>
